import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('PaginationController', PaginationController);

    /** @ngInject */
    function PaginationController($scope, PaginationService) {
        $scope.$watch(
            function () {
                return PaginationService.getter();
            },
            function (newVal, oldVal) {
                if (newVal != null) {
                    $scope.currentPage = newVal.currentPage;
                    $scope.pageSize = newVal.pageSize;
                }
            }
        );

        $scope.changePage = function (value) {
            if (value > $scope.howManyPages()) {
                PaginationService.setter({
                    currentPage: $scope.howManyPages(),
                    pageSize: $scope.pageSize,
                });
            }
            if (value < 1) {
                PaginationService.setter({
                    currentPage: 1,
                    pageSize: $scope.pageSize,
                });
            }
            if (value >= 1 && value <= $scope.howManyPages()) {
                PaginationService.setter({
                    currentPage: value,
                    pageSize: $scope.pageSize,
                });
            }
        };

        $scope.changeHowManyElements = function (
            whichElement,
            howManyToDisplay
        ) {
            angular
                .element(document)
                .find('.howManyPagesPagination')
                .removeClass('active');
            angular
                .element(document)
                .find('.howManyPagesPagination[data-id="' + whichElement + '"]')
                .addClass('active');

            PaginationService.setter({
                currentPage: 1,
                pageSize: howManyToDisplay,
            });
        };

        $scope.nextOrPrevPage = function (option) {
            if (option == 'prev') {
                PaginationService.setter({
                    currentPage: $scope.currentPage - 1,
                    pageSize: $scope.pageSize,
                });
            }
            if (option == 'next') {
                PaginationService.setter({
                    currentPage: $scope.currentPage + 1,
                    pageSize: $scope.pageSize,
                });
            }
        };

        $scope.howManyPages = function () {
            return Math.ceil($scope.countElements / $scope.pageSize);
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/partials/universal_scripts/partials/pagination/scripts/controllers/pagination.controller.ts